import React from "react"
import Skeleton from "react-loading-skeleton"
import DynamicSkeleton from "../../components/DynamicSkeleton"

const columnConfig = {
  Logo: { content: <Skeleton height="70px" width="70px" />, center: true },
  Name: { content: <Skeleton height="20px" width="200px" />, center: true },
  Action: {
    content: (
      <div className="d-flex justify-content-center gap-2">
        <Skeleton height="30px" width="30px" />
        <Skeleton height="30px" width="30px" />
      </div>
    ),
    center: true,
  },
}

const BrandSkeleton = ({ infiniteScroll, rows = 4 }) => {
  return (
    <DynamicSkeleton
      rows={rows}
      columnConfig={columnConfig}
      infiniteScroll={infiniteScroll}
    />
  )
}

export default BrandSkeleton
